import { render, staticRenderFns } from "./Totalization.vue?vue&type=template&id=03ba9af8&scoped=true&"
import script from "./Totalization.vue?vue&type=script&lang=js&"
export * from "./Totalization.vue?vue&type=script&lang=js&"
import style0 from "./Totalization.vue?vue&type=style&index=0&id=03ba9af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ba9af8",
  null
  
)

export default component.exports